module.exports = __webpack_public_path__ + "img/nikolai-lockertsen-office-field-of-dreams.40c5d81.jpg";